// P3-7 frente 2 — ordena las filas de variación de la ficha siguiendo el orden
// PÚBLICO del eje (el menu_order de los términos, medido en docs/p3-7-fase-a).
// Es SOLO para mostrar: las filas se numeran 1,2,3… en ese orden; el orden real
// se cambia en Configuración → Catálogo (global). Función pura, sin red.

const norm = (s) => String(s == null ? '' : s).trim().toLowerCase();

// ejesLista: [{ id, name, slug, terminos: [{ name, slug }] (ya en orden) }].
// Devuelve Map(ejeKey → Map(valorKey → posición 1-based)), con claves por nombre
// y por slug (y `pa_color` también como `color`), para resolver el eje venga como
// venga en la fila.
export function construirPosiciones(ejesLista) {
  const porEje = new Map();
  for (const e of ejesLista || []) {
    const m = new Map();
    (e.terminos || []).forEach((t, i) => {
      if (t && t.name) m.set(norm(t.name), i + 1);
      if (t && t.slug) m.set(norm(t.slug), i + 1);
    });
    if (e.name) porEje.set(norm(e.name), m);
    if (e.slug) {
      porEje.set(norm(e.slug), m);
      if (String(e.slug).startsWith('pa_')) porEje.set(norm(String(e.slug).slice(3)), m);
    }
  }
  return porEje;
}

// Clave de orden de una fila: una posición por eje (los que no se resuelven van
// al final con Infinity). Mono-eje usa attributeName/option; multi-eje, opciones.
export function claveFila(f, porEje) {
  const pares = Array.isArray(f && f.opciones) && f.opciones.length
    ? f.opciones.map((o) => [o.name, o.option])
    : [[f && f.attributeName, f && f.option]];
  return pares.map(([eje, val]) => {
    const m = porEje.get(norm(eje));
    const p = m ? m.get(norm(val)) : undefined;
    return p == null ? Number.POSITIVE_INFINITY : p;
  });
}

// Devuelve una COPIA de vRows ordenada por el orden público del eje (estable: a
// igualdad, conserva el orden original). No muta la entrada.
export function ordenarFilasPorEje(vRows, ejesLista) {
  const porEje = construirPosiciones(ejesLista);
  const conClave = (vRows || []).map((f, i) => ({ f, i, k: claveFila(f, porEje) }));
  conClave.sort((a, b) => {
    const n = Math.max(a.k.length, b.k.length);
    for (let j = 0; j < n; j += 1) {
      const av = a.k[j] == null ? Infinity : a.k[j];
      const bv = b.k[j] == null ? Infinity : b.k[j];
      if (av !== bv) return av - bv;
    }
    return a.i - b.i;
  });
  return conClave.map((x) => x.f);
}
